export default __webpack_public_path__ + "static/media/light_download.885fc033.svg";